module.exports = __webpack_public_path__ + "img/IMG_1962_P.b00d8e90.webp";